import Sentarum1 from '../Sentarum/Sentarum (1).webp'
import Sentarum2 from '../Sentarum/Sentarum (2).webp'
import Sentarum3 from '../Sentarum/Sentarum (3).webp'
import Sentarum4 from '../Sentarum/Sentarum (4).webp'
import Sentarum5 from '../Sentarum/Sentarum (5).webp'
import Sentarum6 from '../Sentarum/Sentarum (6).webp'
import Sentarum7 from '../Sentarum/Sentarum (7).webp'
import Sentarum8 from '../Sentarum/Sentarum (8).webp'
import Sentarum9 from '../Sentarum/Sentarum (9).webp'
import Sentarum10 from '../Sentarum/Sentarum (10).webp'
import Sentarum11 from '../Sentarum/Sentarum (11).webp'
import Sentarum12 from '../Sentarum/Sentarum (12).webp'
import Sentarum13 from '../Sentarum/Sentarum (13).webp'
import Sentarum14 from '../Sentarum/Sentarum (14).webp'

const Sentarumimages =[
Sentarum1,Sentarum2,Sentarum3,Sentarum4,Sentarum5,Sentarum6,Sentarum7,Sentarum8,Sentarum9,Sentarum10,Sentarum11,Sentarum12,Sentarum13,Sentarum14
]

export default Sentarumimages;